import { createSlice } from '@reduxjs/toolkit'
import { loadState, saveState } from '../localStorageFunctions'

const localStorageName = 'provider'
const localStorageState = loadState(localStorageName)
const initialState = localStorageState !== undefined ? localStorageState : {}

export const providerSlice = createSlice({
  name: 'provider',
  initialState: initialState,
  reducers: {
    setProvider: (state, data) => {
      saveState(localStorageName, data.payload)
      return data.payload
    }
  }
})

export const { setProvider } = providerSlice.actions

export default providerSlice.reducer
